export default __webpack_public_path__ + "static/O0254-ddfa77b70be68e6e4636cdb96e636a55.png";